const phoneScamsCommunityImpact = {
  slug: 'phone-scams-community-impact',
  title: 'Impact of phone scams on communities',
  description:
    'How phone fraud affects victims, families, and the wider economy — and why reporting helps everyone.',
  category: 'guides',
  guideType: 'overview',
  readMinutes: 4,
  partnerTip: 'none',
  relatedSlugs: ['protecting-yourself-phone-scams-australia', 'report-phone-scam-australia'],
  sections: [
    {
      type: 'paragraph',
      text: 'Phone scams are not only a personal inconvenience. They cause measurable financial loss, psychological harm, and erode trust in legitimate businesses and government services.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Who is most at risk',
    },
    {
      type: 'list',
      items: [
        'Older Australians targeted by impersonation and remote-access scams',
        'People under financial stress approached with fake investment offers',
        'Anyone receiving high-pressure calls during crises (natural disasters, tax time)',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Broader effects',
    },
    {
      type: 'list',
      items: [
        'Billions lost nationally each year to scams (all channels, ACCC data)',
        'Increased call anxiety — people stop answering legitimate callers',
        'Strain on banks, police, and support services investigating reports',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Why community reporting matters',
    },
    {
      type: 'paragraph',
      text: 'When you report a number on WhoDatNumber and to Scamwatch, patterns emerge faster. Warnings reach others before they lose money. Reports are not a substitute for official action but amplify public awareness.',
    },
    {
      type: 'link',
      to: '/learn/report-phone-scam-australia',
      label: 'How to report a phone scam in Australia',
    },
  ],
};

export default phoneScamsCommunityImpact;

